import { IconWrapper } from '../runtime';
export default IconWrapper('type-alignment', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M4.82442 3.99975H14.2502M11.1759 11.9998H1.75015M1.7002 1.75761V6.2459M14.2502 9.7498V14.242M9.2502 9.99975L11.2502 11.9998L9.2502 13.9998M6.7502 2L4.7502 4L6.7502 6",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});